export default {
  authClientId: process.env.REACT_APP_AUTH_CLIENT_ID,
  poolId: process.env.REACT_APP_AUTH_USER_POOL_ID
};
